import React from 'react'
import { Link } from 'react-router-dom'
import { BooleanField, FunctionField, TextField } from 'react-admin'
import { makeStyles } from '@material-ui/core'
import {
  Button,
  DateField,
  DeleteButton,
  EditButton,
  ListActions,
  ListView
} from '../../components'
import { useAuth } from '../../utils/auth'

const useStyles = makeStyles(theme => ({
  list: {
    marginTop: -theme.spacing(3)
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none'
  }
}))

const getActions = deploymentId => {
  const Actions = props => (
    <ListActions {...props}>
      <Button
        component={Link}
        to={`${props.basePath}/${deploymentId}/scheduled_tasks/create`}
        label="+ Create"
        disableElevation
      />
    </ListActions>
  )
  return Actions
}

const DeploymentTasksEditTab = ({ id }) => {
  const classes = useStyles()
  const Actions = getActions(id)
  const auth = useAuth()
  const canEdit = auth.canEditDeployments()

  return (
    <ListView
      className={classes.list}
      bulkActionButtons={false}
      basePath="/deployments"
      component="div"
      hasCreate={false}
      hasEdit={false}
      hasList
      hasShow={false}
      filter={{ deploymentId: id }}
      resource="deployment_scheduled_tasks"
      sort={{ field: 'name', order: 'ASC' }}
      actions={canEdit ? <Actions /> : null}
    >
      <FunctionField
        label="Name"
        render={record => (
          <Link
            className={classes.link}
            to={`/deployments/${id}/scheduled_tasks/${record.id}/show`}
          >
            {record.name}
          </Link>
        )}
      />
      <TextField label="Type" source="config.scheduleType" />
      <BooleanField label="Enabled" source="enabled" />
      <DateField label="Created At" source="addedDatetime" />
      <DateField label="Updated At" source="changedDatetime" />
      {canEdit && (
        <FunctionField
          render={record => (
            <EditButton
              component={Link}
              to={`/deployments/${id}/scheduled_tasks/${record.id}`}
            />
          )}
        />
      )}
      {canEdit && (
          <FunctionField
            render={record => (
              <DeleteButton
                basePath={`deployments/${id}`}
                record={{ id: record.id, deploymentId: id }}
                resource="deployment_scheduled_tasks"
                redirect={false}
                confirmContent="Are you sure you want to remove this scheduled task?"
              />
            )}
          />
      )}
    </ListView>
  )
}

export default DeploymentTasksEditTab
